import { useEffect, useState } from "react";

// Returns `value` once it has stopped changing for `delay` ms (e.g. to debounce search inputs)
const useDebouncedValue = (value, delay) => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(handler);
  }, [value, delay]);

  return debounced;
};

export default useDebouncedValue;
